import Vue from 'vue';
import Router from 'vue-router';
import Browse from '@/components/browse/Browse';
import ShoppingList from '@/components/shopping-list/ShoppingList';
import New from '@/components/New';
import Recipe from '@/components/recipe/Recipe';
import RecipeForm from '@/components/recipe/RecipeForm';
import EditRecipe from '@/components/recipe/EditRecipe';
import Restaurant from '@/components/restaurant/Restaurant';
import RestaurantForm from '@/components/restaurant/RestaurantForm';
import EditRestaurant from '@/components/restaurant/EditRestaurant';
import Login from '@/components/Login';
import Register from '@/components/Register';
import store from '../store';
import { checkAuthenticated, logout } from '../utils/auth';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/browse',
      meta: { requiresLogin: true },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true,
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
    },
    {
      path: '/browse',
      name: 'browse',
      component: Browse,
      meta: { requiresLogin: true },
    },
    {
      path: '/shoppingList/:id',
      name: 'shoppingList',
      component: ShoppingList,
      props: true,
      meta: { requiresLogin: true },
    },
    {
      path: '/new',
      name: 'new',
      component: New,
      meta: { requiresLogin: true, noBackRoute: true },
      children: [
        {
          path: 'recipe',
          name: 'new-recipe',
          component: RecipeForm,
        },
        {
          path: 'restaurant',
          name: 'new-restaurant',
          component: RestaurantForm,
        },
      ],
    },
    {
      path: '/edit/recipe/:id',
      name: 'edit-Recipe',
      component: EditRecipe,
      props: true,
      meta: { requiresLogin: true },
    },
    {
      path: '/restaurant/:id',
      name: 'Restaurant',
      component: Restaurant,
      props: true,
      meta: { requiresLogin: true },
    },
    {
      path: '/recipe/:id',
      name: 'Recipe',
      component: Recipe,
      props: true,
      meta: { requiresLogin: true },
    },
    {
      path: '/edit/restaurant/:id',
      name: 'edit-Restaurant',
      component: EditRestaurant,
      props: true,
      meta: { requiresLogin: true },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  },
});

// TODO
// TODO
// refactor this to use this.$app.store instead of importing store
router.beforeEach((to, from, next) => {
  if (from.name && !from.meta.noBackRoute) {
    store.state.routed = true;
  }

  const checkFetchInitialData = (innerNext) => {
    if (!store.getters.initDataLoaded) {
      store.dispatch('fetchInitialData').then(() => innerNext());
    } else {
      innerNext();
    }
  };

  if (to.matched.some(route => route.meta.requiresLogin)) {
    if (!checkAuthenticated()) {
      next('/login');
    } else if (!store.getters.user) {
      store.dispatch('fetchUserInfo')
        .then(() => checkFetchInitialData(next))
        .catch(() => {
           // Some kind of error to user?
          logout();
          next('/login');
        });
    } else {
      checkFetchInitialData(next);
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js